import { useAppSelector } from "../../../store/reduxHooks";
import classes from "./BankCredit.module.css";
import { ModifiedBankContent } from "./ModifiedBankContent/ModifiedBankContent";
import { ExternalBankContent } from "./ExternalBankContent/ExternalBankContent";
import { ConfigProvider } from "antd";

// отображение данных о банках в заявке у кредитного специалиста
export function BankCredit() {
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );

  const renderContent = () => {
    if (activeBankInfo.bank.modified_bank) {
      return <ModifiedBankContent />;
    }

    return (
      <ConfigProvider
        theme={{
          components: {
            Select: { controlHeight: 42, colorBorder: "#0000002E" },
            Form: { verticalLabelPadding: "0 0 0.5rem 0", itemMarginBottom: 0 },
          },
        }}
      >
        <ExternalBankContent />
      </ConfigProvider>
    );
  };

  return <div className={classes.bankAppInfoContainer}>{renderContent()}</div>;
}
